var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66675 3.33317C6.66675 2.4127 7.41294 1.6665 8.33342 1.6665H11.6667C12.5872 1.6665 13.3334 2.4127 13.3334 3.33317V6.6665H16.6667C17.5872 6.6665 18.3334 7.4127 18.3334 8.33317V16.6665C18.3334 17.587 17.5872 18.3332 16.6667 18.3332H3.33341C2.41294 18.3332 1.66675 17.587 1.66675 16.6665V11.6665C1.66675 10.746 2.41294 9.99984 3.33341 9.99984H6.66675V3.33317ZM11.6667 16.6665V3.33317L8.33342 3.33317V16.6665H11.6667ZM13.3334 8.33317V16.6665H16.6667V8.33317H13.3334ZM3.33341 11.6665H6.66675V16.6665H3.33341V11.6665Z",
    fill: "#2B391C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.2d524736f7a1b3ea2bd0e5c507b181d4.svg";
export { ForwardRef as ReactComponent };